<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_name"
        placeholder="酒店名称"
        style="width: 220px"
        clearable
        size="mini"
      />

      <el-input
        class="filter-item"
        v-model="listQuery.order_id"
        placeholder="龙腾订单编号"
        style="width: 220px"
        clearable
        size="mini"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.order_confirm_no"
        placeholder="确认号"
        style="width: 200px"
        clearable
        size="mini"
      />
      <el-select
        class="filter-item"
        v-model="listQuery.order_state"
        placeholder="龙腾订单状态"
        style="width: 160px"
        clearable
        size="mini"
      >
        <el-option label="已锁定" :value="2" />
        <el-option label="取消中" :value="7" />
        <el-option label="已取消" :value="8" />
        <el-option label="待确认" :value="9" />
        <el-option label="已确认" :value="10" />
        <el-option label="可入住" :value="27" />
        <el-option label="已入住" :value="28" />
        <el-option label="已离店" :value="29" />
        <el-option label="罚金取消" :value="30" />
      </el-select>

      <el-input
        class="filter-item"
        v-model="listQuery.system_order_no"
        placeholder="系统订单号"
        style="width: 220px"
        clearable
        size="mini"
      />

      <el-button
        class="filter-item"
        type="primary"
        @click="handleFilter"
        size="mini"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      :row-class-name="errorRow"
      size="mini"
    >
      <el-table-column label="下单时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="龙腾订单编号" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_id }}
        </template>
      </el-table-column>
      <el-table-column label="确认号" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_confirm_no || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="订单金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_amount }}
        </template>
      </el-table-column>

      <el-table-column label="入住人姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.guest_name }}
        </template>
      </el-table-column>

      <el-table-column label="入住时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_in }}
        </template>
      </el-table-column>

      <el-table-column label="离店时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_out }}
        </template>
      </el-table-column>

      <el-table-column label="酒店名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="房间名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="房间间数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_num }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="锦江订单支付总价" min-width="140" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.total_rate }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="龙腾订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.order_status_id === '2'"
            >已锁定</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.order_status_id === '7'"
            >取消中</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.order_status_id === '8'"
            >已取消</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.order_status_id === '9'"
            >待确认</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.order_status_id === '10'"
            >已确认</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.order_status_id === '27'"
            >可入住</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.order_status_id === '28'"
            >已入住</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.order_status_id === '29'"
            >已离店</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.order_status_id === '30'"
            >罚金取消</el-tag
          >
        </template>
      </el-table-column>

      <!--      <el-table-column label="锦江支付状态" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-tag type="info" v-if="scope.row.pay_state === 0">未付款</el-tag>-->
      <!--          <el-tag type="success" v-else-if="scope.row.pay_state === 1">已付款</el-tag>-->
      <!--          <el-tag type="warning" v-else-if="scope.row.pay_state === 2">退款处理中</el-tag>-->
      <!--          <el-tag type="danger" v-else-if="scope.row.pay_state === 3">已退款</el-tag>-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="系统订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.customer_order_id }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="系统订单状态" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-tag type="info" v-if="scope.row.system_order_status === 100">下单待处理</el-tag>-->
      <!--          <el-tag type="success" v-else-if="scope.row.system_order_status === 101">下单成功</el-tag>-->
      <!--          <el-tag type="danger" v-else-if="scope.row.system_order_status === 102">下单失败</el-tag>-->
      <!--          <el-tag type="success" v-else-if="scope.row.system_order_status === 201">取消订单成功</el-tag>-->
      <!--          <el-tag type="danger" v-else-if="scope.row.system_order_status === 202">取消订单失败</el-tag>-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="操作处理失败信息" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.handle_error_message }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column
        v-if="$canEdit"
        label="操作"
        width="250"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!--          <el-button type="warning" size="mini" @click="handleModifyLastArrTime(scope.row)" :disabled="scope.row.system_order_status !== 102">修改到店时间</el-button>-->

          <!--          <el-button type="warning" size="mini" @click="handleReOrder(scope.row)" :disabled="!(scope.row.system_order_status === 102)">重新下单</el-button>-->

          <el-button
            type="warning"
            size="mini"
            @click="handleCancelOrder(scope.row)"
            :disabled="scope.row.order_status_id === '8'"
            >取消订单</el-button
          >

          <!--          <el-button type="warning" size="mini" @click="handleComplete(scope.row)" :disabled="handleCompleteStatus(scope.row)">处理完成</el-button>-->
          <el-button type="warning" size="mini" @click="syncOrder(scope.row)"
            >同步订单</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 修改到店时间 -->
    <el-dialog
      title="修改到店时间"
      :visible.sync="dialogVisibleModifyLastArrTime"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="modifyLastArrTimeForm"
        :rules="modifyLastArrTimeRules"
        :model="modifyLastArrTimeForm"
        label-width="150px"
      >
        <el-form-item label="修改到店时间" prop="last_arr_time">
          <el-date-picker
            v-model="modifyLastArrTimeForm.last_arr_time"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleModifyLastArrTime = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveDataModifyLastArrTime"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改到店时间 -->
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_name: '',
        order_id: '',
        state: '',
        order_code: '',
        order_state: '',
        system_order_no: '',
        system_order_status: '',
      },
      // 修改到店时间
      btnLoading: false,
      dialogVisibleModifyLastArrTime: false,
      modifyLastArrTimeForm: {
        order_id: '',
        last_arr_time: '',
      },
      modifyLastArrTimeRules: {
        last_arr_time: [
          { required: true, message: '到店时间不能为空', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/longTeng/order/orderList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    errorRow({ row }) {
      let errorStatus = [102, 202]
      if (
        errorStatus.includes(row.system_order_status) &&
        row.error_order_handle_status === 0
      ) {
        return 'error-row'
      }
      return ''
    },
    // 修改到店时间
    handleModifyLastArrTime(row) {
      this.modifyLastArrTimeForm = {
        order_id: row.order_id,
        last_arr_time: row.last_arr_time,
      }
      this.dialogVisibleModifyLastArrTime = true
      this.$nextTick(() => {
        this.$refs['modifyLastArrTimeForm'].clearValidate() //清除校验结果
      })
    },
    saveDataModifyLastArrTime() {
      this.$refs['modifyLastArrTimeForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/longTeng/order/modifyLastArrTime',
            method: 'post',
            data: this.modifyLastArrTimeForm,
          })
            .then(() => {
              this.dialogVisibleModifyLastArrTime = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 重新下单
    handleReOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/longTeng/order/reOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 取消订单
    handleCancelOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/longTeng/order/cancelOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 处理完成
    handleComplete(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/longTeng/order/handleComplete',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 同步订单
    syncOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/longTeng/order/syncOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    handleCompleteStatus(row) {
      let errorStatus = [102, 202]
      return !(
        errorStatus.includes(row.system_order_status) &&
        row.error_order_handle_status === 0
      )
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}
</style>
